<div class="container modern-container">
  <!-- Page Header -->
  <div class="page-header">
    <div class="header-content">
      <div class="header-icon">
        <i class="fas fa-user-graduate"></i>
      </div>
      <div class="header-text">
        <h2 class="page-title">Student Resources</h2>
        <p class="page-subtitle">Essential resources and schedules for students</p>
      </div>
    </div>
  </div>

  <div class="card modern-card shadow-lg">
    <div class="card-body">
      <h5 class="card-title">
        <i class="fas fa-users me-2"></i>Student Information & Resources
      </h5>
      <hr class="title-divider">

      <div class="col-12">
        <!-- Student Documents Section -->
        <div class="section-wrapper">
          <h6 class="section-title">
            <i class="fas fa-folder-open me-2"></i>Student Documents
          </h6>
          <ul class="list-group modern-list">
            <li class="list-group-item modern-item" *ngFor="let link of studentList; let i=index">
              <div class="item-wrapper">
                <div class="item-icon">
                  <i class="fas fa-file-alt"></i>
                  <span class="item-number">{{i + 1}}</span>
                </div>
                <div class="item-content">
                  <a [href]="link.filename" target="_blank" class="item-link">
                    {{link.displayText}}
                  </a>
                  <span class="item-meta">
                    <i class="fas fa-download"></i> Download or view document
                  </span>
                </div>
                <div class="item-actions">
                  <button class="btn btn-sm btn-primary" data-bs-toggle="modal" [attr.data-bs-target]="'#studentModal'+i">
                    <i class="fas fa-eye"></i> View
                  </button>
                </div>
              </div>
            </li>
          </ul>
        </div>

        <!-- Timetable Section -->
        <div class="section-wrapper mt-4">
          <h6 class="section-title">
            <i class="fas fa-clock me-2"></i>Timetable & Schedules
          </h6>
          <ul class="list-group modern-list">
            <li class="list-group-item modern-item" *ngFor="let links of timetable; let i=index">
              <div class="item-wrapper">
                <div class="item-icon">
                  <i class="fas fa-calendar"></i>
                  <span class="item-number">{{i + 1}}</span>
                </div>
                <div class="item-content">
                  <a [href]="links.filename" target="_blank" class="item-link">
                    {{links.displayText}}
                  </a>
                  <span class="item-meta">
                    <i class="fas fa-eye"></i> View timetable
                  </span>
                </div>
                <div class="item-actions">
                  <button class="btn btn-sm btn-primary" data-bs-toggle="modal" [attr.data-bs-target]="'#timetableModal'+i">
                    <i class="fas fa-eye"></i> View
                  </button>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>

  <!-- Info Section -->
  <div class="row mt-4 info-section">
    <div class="col-md-4">
      <div class="info-card">
        <div class="info-icon bg-resources">
          <i class="fas fa-book-reader"></i>
        </div>
        <h5>Study Materials</h5>
        <p>Access comprehensive study materials and reference books.</p>
      </div>
    </div>
    <div class="col-md-4">
      <div class="info-card">
        <div class="info-icon bg-schedule">
          <i class="fas fa-calendar-alt"></i>
        </div>
        <h5>Class Schedule</h5>
        <p>View updated class timetables and examination schedules.</p>
      </div>
    </div>
    <div class="col-md-4">
      <div class="info-card">
        <div class="info-icon bg-support">
          <i class="fas fa-hands-helping"></i>
        </div>
        <h5>Student Support</h5>
        <p>Get help with academic and non-academic concerns.</p>
      </div>
    </div>
  </div>
</div>

<!-- PDF Viewer Modals - Outside container for proper z-index -->
<ng-container *ngFor="let link of studentList; let i=index">
  <app-pdf-viewer [title]="link.displayText" [url]="link.filename" [id]="'studentModal'+i" [hideButton]="true"></app-pdf-viewer>
</ng-container>
<ng-container *ngFor="let links of timetable; let i=index">
  <app-pdf-viewer [title]="links.displayText" [url]="links.filename" [id]="'timetableModal'+i" [hideButton]="true"></app-pdf-viewer>
</ng-container>